(async () => {
  const formElements: NodeListOf<HTMLElement> = document.querySelectorAll('[data-wffm]');
  if (formElements.length === 0) {
    return;
  }

  // Load WFFM related code only if there're forms on the page.
  await import('./app/module');
})();
